import { Autocomplete, Box, TextField } from '@mui/material'
import { customModelLabel } from '@/features/mockModel/customProviders'
import styles from './customModelDialog.module.scss'

const FIELD_ID = 'custom-model-model'

/** The provider's main models to pick from, or any model id typed in. */
export default function ModelField({ provider, value, error, onChange }) {
  const label = provider.modelLabel ?? 'Model'
  const hasModels = provider.models.length > 0
  return (
    <Box className={styles.section}>
      <label className={styles.label} htmlFor={FIELD_ID}>
        {label}
      </label>
      <Autocomplete
        id={FIELD_ID}
        freeSolo
        options={provider.models.map((model) => model.id)}
        value={value}
        inputValue={value}
        onChange={(_event, next) => onChange(next ?? '')}
        onInputChange={(_event, next) => onChange(next)}
        renderOption={({ key, ...props }, id) => (
          <li key={key} {...props}>
            <span className={styles.optionLabel}>{customModelLabel(provider.id, id)}</span>
            <span className={styles.optionId}>{id}</span>
          </li>
        )}
        renderInput={(params) => (
          <TextField
            {...params}
            variant="outlined"
            className={styles.input}
            error={Boolean(error)}
            placeholder={hasModels ? 'Choose or type a model ID' : 'e.g. gpt-4o-production'}
          />
        )}
      />
      {error ? <span className={`${styles.helper} ${styles.error}`}>{error}</span> : null}
    </Box>
  )
}
